import React from "react";

const BannerSkeletonLoader = () => {
  return (
    <div className="w-full bg-base_300 animate-pulse xl:h-[400px] rounded-md"></div>
  );
};

export default BannerSkeletonLoader;
